import React, { useState, useEffect } from "react";
import { getExpenseItems, saveExpenseItems } from "./storage";

const EstimationPage = () => {
  const [expenseItems, setExpenseItems] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const items = getExpenseItems();
    setExpenseItems(items);
  }, []);

  // Add new expense
  const handleAddItem = (newItem) => {
    const maxId = expenseItems.length > 0 ? Math.max(...expenseItems.map((item) => item.id)) : 0;
    const updatedItems = [
      ...expenseItems,
      { id: maxId + 1, ...newItem, bids: [], selectedBid: null },
    ];
    setExpenseItems(updatedItems);
    saveExpenseItems(updatedItems);
    setShowModal(false);
  };

  // Submit a bid
  const handleSubmitBid = (itemId, bid) => {
    const updatedItems = expenseItems.map((item) =>
      item.id === itemId ? { ...item, bids: [...item.bids, bid] } : item
    );
    setExpenseItems(updatedItems);
    saveExpenseItems(updatedItems);
  };

  // Select
  const handleSelectBid = (itemId, bid) => {
    const updatedItems = expenseItems.map((item) =>
      item.id === itemId ? { ...item, selectedBid: bid } : item
    );
    setExpenseItems(updatedItems);
    saveExpenseItems(updatedItems);
  };

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-semibold mb-6">Estimation</h1>
      <button className="btn btn-primary mb-4" onClick={() => setShowModal(true)}>
        Add New Expense Item
      </button>
      {showModal && (
        <AddExpenseItemModal
          onClose={() => setShowModal(false)}
          onAdd={handleAddItem}
        />
      )}
      <div className="grid grid-cols-1 gap-4">
        {expenseItems.map((item) => (
          <ExpenseItemCard
            key={item.id}
            item={item}
            onSubmitBid={handleSubmitBid}
            onSelectBid={handleSelectBid}
          />
        ))}
      </div>
    </div>
  );
};

// Modal, new expense
const AddExpenseItemModal = ({ onClose, onAdd }) => {
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  // Example categories (for now)
  const budgetCategories = ["03 - Concrete", "04 - Masonry", "05 - Metals"];

  const handleSubmit = (e) => {
    e.preventDefault();
    onAdd({ category, description });
    setCategory("");
    setDescription("");
  };

  return (
    <div className="modal modal-open">
      <div className="modal-box">
        <h3 className="font-bold text-lg">Add New Expense Item</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-control">
            <label className="label">Category</label>
            <select
              className="select select-bordered"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              required
            >
              <option value="">Select a category</option>
              {budgetCategories.map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
          </div>
          <div className="form-control">
            <label className="label">Description</label>
            <textarea
              className="textarea textarea-bordered"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </div>
          <div className="modal-action">
            <button type="submit" className="btn btn-primary">
              Add Item
            </button>
            <button type="button" className="btn" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// Card, expense and bids
const ExpenseItemCard = ({ item, onSubmitBid, onSelectBid }) => {
  const [contractor, setContractor] = useState("");
  const [amount, setAmount] = useState("");

  const handleBidSubmit = (e) => {
    e.preventDefault();
    if (contractor && amount) {
      onSubmitBid(item.id, { contractor, amount: parseFloat(amount) });
      setContractor("");
      setAmount("");
    }
  };

  return (
    <div className="card bg-base-100 shadow-xl">
      <div className="card-body">
        <h2 className="card-title">{item.category}</h2>
        <p>{item.description}</p>
        <h3 className="font-semibold mt-4">Bids:</h3>
        {item.bids.length > 0 ? (
          <table className="table w-full">
            <thead>
              <tr>
                <th>Contractor</th>
                <th>Amount</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {item.bids.map((bid, index) => (
                <tr
                  key={index}
                  className={item.selectedBid === bid ? "bg-success bg-opacity-20" : ""}
                >
                  <td>{bid.contractor}</td>
                  <td>${bid.amount.toFixed(2)}</td>
                  <td>
                    {!item.selectedBid && (
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() => onSelectBid(item.id, bid)}
                      >
                        Select
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No bids yet.</p>
        )}
        <form onSubmit={handleBidSubmit} className="mt-4">
          <div className="flex gap-2">
            <input
              type="text"
              placeholder="Contractor Name"
              className="input input-bordered"
              value={contractor}
              onChange={(e) => setContractor(e.target.value)}
              required
            />
            <input
              type="number"
              placeholder="Bid Amount"
              className="input input-bordered"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              step="0.01"
              required
            />
            <button type="submit" className="btn btn-primary">
              Submit Bid
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EstimationPage;
